import useFormatText from "../../hooks/useFormatText";
import "./style.css"

function Textarea({ label, text }) {
    const formattedDescription = useFormatText(text ? text : "");

    return (
        <div className='textarea_comp'>
            {label && <span className="label">{label} :</span>}
            <p className="text">{formattedDescription}</p>
        </div>
    )
}

export default Textarea;